import { ThemeProvider, useTheme } from "@material-ui/styles"
import { Fragment, useContext, useEffect, useState } from "react"
import TLServiceComponent from "../../../../../contexts/TLServiceComponent"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useActions } from "../../../../../utils/action-helper"
import {
  tableSetData,
  tableSetDialog,
  tableSetSelected,
} from "../../../../../actions"
import style from './style.module.sass'
import TableContainer from '@material-ui/core/TableContainer'
import { Delete, Settings } from '@material-ui/icons'
import TableHead from '@material-ui/core/TableHead'
import { contrastCheckBox, convertFromErrorObject, convertedValue, isObjectEmpty } from "../../../../../utils"
import { Box, Button, Checkbox, Collapse, createTheme, Modal, Table, TableBody, TableCell, TableRow } from "@material-ui/core"
import Spinner from "../../../../Spinner"
import closeIcon from "../../../../../assets/close-circle.svg"
import { Alert } from "@mui/material"
import config from "../../../../../config"


export default function TableInnerComponent({
  row,
  index,
  isBlueRow,
  setTerminologyModal,
  setCurrentTerm,
  callEndPoint
}) {

  const { theme: { bgColors, colors } } = useTheme()
  const { t, i18n: { language: i18nLanguage } } = useTranslation()
  const tlService = useContext(TLServiceComponent)

  const selected = useSelector(state => state.tableData.selected)
  const disabledColumns = useSelector(state => state.tableData.disabledColumns)
  const data = useSelector(state => state.tableData.data)
  const columns = useSelector(state => state.tableData.columns)
  const token = useSelector(state => state.userData.token)


  const [extraData, setExtraData] = useState({})
  const [spinner, setSpinner] = useState(false)
  const [termModal, setTermModal] = useState(false)
  const [deleteAlertMsg, setDeleteAlertMsg] = useState()
  const [deleteRecall, setDeleteRecall] = useState()

  const {
    aTableSetSelected,
    aTableSetData,
    aTableSetDialog
  } = useActions({
    aTableSetData: tableSetData,
    aTableSetSelected: tableSetSelected,
    aTableSetDialog: tableSetDialog,
  })

  const dialogType = useSelector(state => state.tableData.dialog.type)
  const dialogOpen = useSelector(state => state.tableData.dialog.open)
  const dialogResponse = useSelector(state => state.tableData.dialog.response)
  const customTheme = contrastCheckBox(colors, createTheme)

  const deleteTerm = async (e, id) => {
    e.preventDefault()
    try {
      await tlService.deleteTermCategory(token, id)
      setTermModal(false)
      setDeleteRecall(id)
    } catch (e) {
      setDeleteAlertMsg(convertFromErrorObject(t, e))
      setTimeout(() => {
        setDeleteAlertMsg('')
      }, config.timeOutDuration)
    }
  }

  useEffect(() => {
    async function fetchData() {
      if (!dialogOpen && dialogType) {
        switch (dialogType) {
          case 'deleteTerm':
            if (dialogResponse && !isObjectEmpty(extraData)) {
              const term_id = extraData.id
              try {
                await tlService.deleteTermCategory(token, term_id)
                setTermModal(false)
                setDeleteRecall(term_id)
                const tData = [...data]
                tData.splice(index, 1)
                aTableSetData(tData)
              } catch (error) {
                console.log('deleterTerm', error)
                aTableSetDialog({
                  type: 'errorDeleteTerm',
                  open: true,
                  RequestComponent: () => <>{convertFromErrorObject(t, error)}</>,
                  response: null,
                  buttons: {
                    yes: false,
                    no: false,
                    close: true,
                    save: false
                  }
                })
              }
            }
            break
          default:
            break
        }
        setExtraData({})
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogOpen, dialogType])

  const handleSelectItem = (id) => {
    const tSelected = [...selected]
    const idx = tSelected.indexOf(id)
    if (idx > -1) {
      tSelected.splice(idx, 1)
    } else {
      tSelected.push(id)
    }
    aTableSetSelected(tSelected.sort())
  }

  const handleOpenItem = (inx) => {
    const tData = [...data]
    tData[inx]['opened'] = !row?.opened
    aTableSetData(tData)
  }

  const handleDeleteTerm = async (row) => {
    setExtraData(row)
    aTableSetDialog({
      type: 'deleteTerm',
      open: true,
      RequestComponent: () => <>{t('admin_term_delete-term')}</>,
      response: null,
      buttons: {
        yes: true,
        no: true,
        close: false,
        save: false
      }
    })

  }

  const EmptyCell = () => {
    return <TableCell
      onClick={() => handleOpenItem(index)}
      className={style.emptyColumns}
      component="th"
      scope="row"
      padding="none" />
  }

  /* VIEW */
  const isItemSelected = selected.includes(row.id)

  if (spinner)
    return <div className={'w-100 align-content-center text-center align-items-center'}><Spinner /></div>

  return (
    <>
      <Modal open={termModal} onClose={() => setTermModal(false)} style={{ width: '50%', margin: '0 auto', marginTop: '20%', height: '300px' }}>
        <div className={`${style.modalMainCont} pb-3`} style={{ backgroundColor: bgColors.bgPrimary0 }}>
          <div className={`${style.head} d-flex justify-content-between p-1 pl-3`}
            style={{ backgroundColor: bgColors.bgPrimary400 }}>
            <p className={`m-0 ${style.title}`} style={{ color: 'white', fontSize: '25px' }}>
              {t('clear-terms')}
            </p>
            <button className={`border-0 bg-transparent`} onClick={() => setTermModal(false)}>
              <img src={closeIcon} alt="" />
            </button>
          </div>
          <br />
          <div className={style.error} >
            <Collapse in={!!deleteAlertMsg} >
              <Alert
                className={`m-0`}
                severity='error'>
                <h6 className={`m-0`}>
                  {/* {t('delete-error-msg')} */}
                  {deleteAlertMsg}
                </h6>
              </Alert>
            </Collapse>
          </div>
          <div>
            <Button color='primary' variant='contained' onClick={(e) => deleteTerm(e, row.id)} style={{ marginLeft: '40%', marginTop: '4%' }}>
              {t('yes')}
            </Button>
            <Button color='primary' variant='contained' onClick={() => { setTermModal(false) }} style={{ marginLeft: '4%', marginTop: '4%' }}>
              {t('no')}
            </Button>
          </div>
        </div>
      </Modal>
      <TableRow
        style={{ backgroundColor: isItemSelected ? bgColors.bgBlue300 : isBlueRow ? bgColors.bgPrimary0 : bgColors.bgBlue100 }}
        hover
        aria-selected={isItemSelected}
        tabIndex={-1}
        key={row.id}
      >
        <TableCell className={style.cell} padding="checkbox" onClick={() => handleSelectItem(row.id)}>
          <ThemeProvider theme={customTheme}>
            <Checkbox
              checked={isItemSelected}
              color="primary"
              inputProps={{ 'aria-label': isItemSelected ? t('Deselect') : t('Select') }}
            />
          </ThemeProvider>
        </TableCell>
        {columns.map((col, ind) =>
          <Fragment key={ind}>
            {disabledColumns.includes(col.id) ? <EmptyCell /> :
              <>
                <TableCell
                  onClick={() => handleOpenItem(index)}
                  className={style.otherColumns}
                  component="th"
                  style={{ color: colors.colorText }}
                  scope="row"
                  padding="none">
                  {(() => {
                    switch (col.id) {
                      case 'name':
                        return convertedValue(
                          row[col.id][i18nLanguage] ? row[col.id][i18nLanguage] : "",
                          col.type,
                          i18nLanguage,
                          t,
                          {},
                          {}
                        )

                      case 'category_type':
                        return t(`admin_term_type_${convertedValue(row[col.id], col.type, i18nLanguage, t, {}, row)}`)

                      default:
                        return convertedValue(
                          row[col.id],
                          col.type,
                          i18nLanguage,
                          t,
                          {},
                          row,
                          false,
                          bgColors,
                          colors
                        )
                    }
                  })()}
                </TableCell>
              </>
            }
          </Fragment>)
        }
        <TableCell className={`${style.cell} d-flex`} align="right">
          <div className={style.buttonCell}>
            <Button variant="contained" color="primary" size="small"
              style={{
                padding: '4px',
                minWidth: '30px',
                backgroundColor: bgColors.bgProgress20,
                color: colors.colorPrimary0
              }}
              onClick={() => handleDeleteTerm(row)}>
              <Delete fontSize="small" />
            </Button>
          </div>
          <div className={style.buttonCell}>


            <Button variant="contained" color="primary" size="small"
              style={{
                padding: '4px',
                minWidth: '30px',
                backgroundColor: bgColors.bgBlue1000,
                color: colors.colorPrimary0
              }}
              onClick={() => {
                setTerminologyModal(s => !s)
                setCurrentTerm(row)
                callEndPoint()
              }
              }
            >
              <Settings fontSize="small" />
            </Button>

          </div>
        </TableCell>
      </TableRow>
      <TableRow className={`${style.accordion}`}
        style={{ backgroundColor: isItemSelected ? bgColors.bgBlue300 : isBlueRow ? bgColors.bgPrimary0 : bgColors.bgBlue100 }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse className={'p-1'} in={row.opened} timeout="auto" unmountOnExit>
            <Box style={{ color: colors.colorPrimary500, gridGap: 5 }}
              className={`mb-4 d-flex justify-content-between pt-2`}
              margin={1}>
              <div className={'d-flex text-center w-100'}>
                <div style={{ width: '100%', maxHeight: '200px', overflowY: 'scroll' }}>
                  <TableContainer>
                    <Table style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell className={style.smallTableHeader} style={{ width: '15%' }}>{t('id')}</TableCell>
                          <TableCell className={style.smallTableHeader} style={{ width: '25%' }}>{t('admin_user_desc')}</TableCell>
                          <TableCell className={style.smallTableHeader} style={{ width: '30%' }}>{t('admin_user_create-time')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.opened &&
                          <Fragment key={row.id}>
                            <TableRow
                              key={row.id}>
                              <TableCell 
                                style={{ color: colors.colorText }}
                                className={style.smallTable}>
                                {convertedValue(row.id, 'numeric', i18nLanguage, t)}</TableCell>
                              <TableCell 
                                style={{ color: colors.colorText }}
                                className={style.smallTable}>{convertedValue(row.description[i18nLanguage] ? row.description[i18nLanguage] : "", 'string', i18nLanguage, t)}</TableCell>
                              <TableCell 
                                style={{ color: colors.colorText }}
                                className={style.smallTable}>{convertedValue(row.create_time, 'date', i18nLanguage, t)}</TableCell>
                            </TableRow>
                          </Fragment>}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <div>
                </div>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}